import { IconButton_IconSizes, IconButtonSize } from '@ydistri/ds';
import React, { useMemo } from 'react';
import { AiOutlineEye, AiOutlineEyeInvisible } from 'react-icons/ai';
import CalculationAction from './CalculationAction';

interface PrivateCalculationIconProps {
  disabled?: boolean;
  loading?: boolean;
  tooltip: string;
  value: boolean;
  onClick: () => void;
  size?: IconButtonSize;
}

const PrivateCalculationIcon: React.FC<PrivateCalculationIconProps> = ({
  value,
  size = 'normal',
  ...rest
}: PrivateCalculationIconProps) => {
  const iconHide = useMemo(
    () => <AiOutlineEyeInvisible size={IconButton_IconSizes[size]} />,
    [size],
  );
  const iconShow = useMemo(() => <AiOutlineEye size={IconButton_IconSizes[size]} />, [size]);

  return (
    <CalculationAction
      size={size}
      icon={value ? iconHide : iconShow}
      tooltipPosition="left"
      checked={value}
      {...rest}
    />
  );
};

export default PrivateCalculationIcon;
